export class CareSkill {
	readonly id: number;
	name: string;

	constructor(
		options: {
			name?: string;
			id?: number;
		} = {}
	) {
		this.name = options.name || null;
		this.id = options.id || null;
	}
}
